import { useEffect } from 'react';
import { createChatSocket } from '../realtime/ChatSocket';
import { useChatStore } from '../store/useChatStore';

export function useChatRealtime({ communityId, isAdmin }) {
    const applyRealtime = useChatStore((state) => state.applyRealtime);
    const loadUnread = useChatStore((state) => state.loadUnread);
    const loadPendingCount = useChatStore((state) => state.loadPendingCount);
    const conversations = useChatStore((state) => state.conversations);

    useEffect(() => {
        if (!communityId) {
            return undefined;
        }
        const socket = createChatSocket({
            communityId,
            isAdmin,
            onEvent: (envelope) => applyRealtime(envelope),
            onAdminEvent: (envelope) => applyRealtime(envelope),
        });
        loadUnread(communityId);
        if (isAdmin) {
            loadPendingCount(communityId);
        }
        return () => socket.disconnect();
    }, [communityId, isAdmin, applyRealtime, loadUnread, loadPendingCount]);

    useEffect(() => {
        if (!communityId || !conversations.length) {
            return;
        }
        const after = conversations.map((row) => ({
            id: row.id,
            seq: row.lastSeq || 0,
        }));
        after.forEach((row) => {
            useChatStore.getState().catchUp(communityId, row.id, row.seq);
        });
    }, [communityId, conversations.length]);
}
